import ReactDOM from "react-dom/client";
import App from "./App";
import { UserContextProvider } from "./store/userContext";

// import * as Sentry from "@sentry/react";

import "./fonts/index.css";
import "./index.css";

// const hostname = window.location.hostname;
// const isTest =
//   hostname.includes("localhost") ||
//   hostname.includes("dev") ||
//   hostname.includes("testing");

// if (!isTest) {
//   Sentry.init({
//     dsn: "https://3b6e008d47be03caa93bab46d8143512@o4509078567780352.ingest.de.sentry.io/4509253762875472",
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true,
//     integrations: [Sentry.replayIntegration()],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//     ignoreErrors: [
//       /Unexpected identifier 'Unavailable'/i, // external api error (not realized)
//       /Service Unavailable/i, // external api error
//       /Loading chunk \d+ failed/i, // external backend package error
//       /Can't find variable: chalk/i, // external backend package error
//       /ReferenceError.*chalk/i, // external backend package error
//       /feature named `clickToLoad` was not found/i, // external browser error
//     ],
//   });
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <UserContextProvider>
    <App />
  </UserContextProvider>,
);
